"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/Button"));
var _SelectInput = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/form/SelectInput"));
var _TextInput = require("@oberoninternal/travelbase-ds/components/form/TextInput");
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _grid = require("@rebass/grid");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Yup = _interopRequireWildcard(require("yup"));
var _messages = _interopRequireDefault(require("../constants/messages"));
var _Fieldset = _interopRequireDefault(require("./designsystem/Fieldset"));
var _StyledCaret = _interopRequireDefault(require("./designsystem/StyledCaret"));
var _Formed = _interopRequireDefault(require("./Formed"));
var _Stack = _interopRequireDefault(require("./Stack"));
var _TenantContext = require("../context/TenantContext");
var _ReviewModal = require("./ReviewModal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const initialValues = {
  title: '',
  ratingActivity: '',
  ratingHospitality: '',
  ratingValueForMoney: '',
  comment: '',
  tips: ''
};
const ActivityReviewForm = ({
  handleSubmit,
  activityName
}) => {
  const intl = (0, _reactIntl.useIntl)();
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const reviewOptions = (0, _ReviewModal.getReviewOptions)(intl);
  const validationSchema = Yup.object().shape({
    title: Yup.string().max(65, intl.formatMessage(_messages.default.maximumCharsError, {
      maxLength: 65
    })).required(intl.formatMessage(_messages.default.fieldError)),
    ratingActivity: Yup.number().required(intl.formatMessage(_messages.default.fieldError)),
    ratingHospitality: Yup.number().required(intl.formatMessage(_messages.default.fieldError)),
    ratingValueForMoney: Yup.number().required(intl.formatMessage(_messages.default.fieldError)),
    comment: Yup.string().max(500, intl.formatMessage(_messages.default.maximumCharsError, {
      maxLength: 500
    })).required(intl.formatMessage(_messages.default.fieldError)),
    tips: Yup.string()
  });
  return __jsx(_Formed.default, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    handleSubmit: handleSubmit
  }, ({
    isSubmitting
  }) => __jsx(_react.default.Fragment, null, __jsx(BoldBody, null, __jsx(_reactIntl.FormattedMessage, {
    id: "Kmxghz",
    defaultMessage: [{
      "type": 0,
      "value": "Beoordeel "
    }, {
      "type": 1,
      "value": "activity"
    }],
    values: {
      activity: activityName ?? 'Activiteit'
    }
  })), __jsx(_Stack.default, {
    mt: "2.4rem",
    spacing: 3,
    mb: [0, 7]
  }, __jsx(_Fieldset.default, {
    variant: "large",
    label: __jsx(_reactIntl.FormattedMessage, {
      id: "G/B/WM",
      defaultMessage: [{
        "type": 0,
        "value": "Hoe beoordeel je de activiteit?"
      }]
    }),
    id: "ratingActivity"
  }, __jsx(ReviewSelectInput, {
    name: "ratingActivity",
    options: reviewOptions,
    hideChoices: true,
    ToggleComponent: _StyledCaret.default,
    placeholder: __jsx(_reactIntl.FormattedMessage, {
      id: "oRjnDy",
      defaultMessage: [{
        "type": 0,
        "value": "Kies een cijfer"
      }]
    })
  })), __jsx(_Fieldset.default, {
    variant: "large",
    label: __jsx(_reactIntl.FormattedMessage, {
      id: "p5S1Ir",
      defaultMessage: [{
        "type": 0,
        "value": "Hoe beoordeel je de organisatie (onvangst/begeleiding) bij de activiteit?"
      }]
    }),
    id: "ratingHospitality"
  }, __jsx(ReviewSelectInput, {
    name: "ratingHospitality",
    options: reviewOptions,
    hideChoices: true,
    ToggleComponent: _StyledCaret.default,
    placeholder: __jsx(_reactIntl.FormattedMessage, {
      id: "oRjnDy",
      defaultMessage: [{
        "type": 0,
        "value": "Kies een cijfer"
      }]
    })
  })), __jsx(_Fieldset.default, {
    variant: "large",
    label: __jsx(_reactIntl.FormattedMessage, {
      id: "s6OIZe",
      defaultMessage: [{
        "type": 0,
        "value": "Hoe beoordeel je de prijs in verhouding to wat je kreeg?"
      }]
    }),
    id: "ratingValueForMoney"
  }, __jsx(ReviewSelectInput, {
    name: "ratingValueForMoney",
    options: reviewOptions,
    hideChoices: true,
    ToggleComponent: _StyledCaret.default,
    placeholder: __jsx(_reactIntl.FormattedMessage, {
      id: "oRjnDy",
      defaultMessage: [{
        "type": 0,
        "value": "Kies een cijfer"
      }]
    })
  }))), __jsx(_grid.Box, {
    mb: [2, 5]
  }, __jsx(BoldBody, null, __jsx(_reactIntl.FormattedMessage, {
    id: "1rsJBI",
    defaultMessage: [{
      "type": 0,
      "value": "Omschrijf jouw ervaring in één korte zin."
    }]
  })), __jsx(SummaryInputField, {
    name: "title"
  }), __jsx(NeutralBody, {
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "sNN7v3",
    defaultMessage: [{
      "type": 0,
      "value": "We plaatsen deze zin als 'titel van jouw ervaring' boven je beoordeling. Bijvoorbeeld: “Veel gelachen en geleerd” of “Bijzonder om "
    }, {
      "type": 1,
      "value": "partner"
    }, {
      "type": 0,
      "value": " zo te ontdekken”"
    }],
    values: {
      partner: brandConfig.name
    }
  }))), __jsx(_grid.Box, {
    mb: 7
  }, __jsx(BoldBody, null, __jsx(_reactIntl.FormattedMessage, {
    id: "J3TG53",
    defaultMessage: [{
      "type": 0,
      "value": "Toelichting"
    }]
  })), __jsx(TextArea, {
    name: "comment"
  }), __jsx(NeutralBody, {
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "AoviFq",
    defaultMessage: [{
      "type": 0,
      "value": "Hier vertel je meer over je ervaring. Bijvoorbeeld: 'We hebben een deel van "
    }, {
      "type": 1,
      "value": "partner"
    }, {
      "type": 0,
      "value": " gezien dat we als ervaren "
    }, {
      "type": 1,
      "value": "partner"
    }, {
      "type": 0,
      "value": " gangers nooit hadden bezocht” of 'Je hebt echt een paar goeie schoenen nodig voor deze wandeling'."
    }],
    values: {
      partner: brandConfig.name
    }
  }))), __jsx(_grid.Box, null, __jsx(BoldBody, null, __jsx(_reactIntl.FormattedMessage, {
    id: "loM2sl",
    defaultMessage: [{
      "type": 0,
      "value": "Tip voor de organisator"
    }]
  })), __jsx(TextArea, {
    name: "tips"
  }), __jsx(NeutralBody, {
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "MtU6VS",
    defaultMessage: [{
      "type": 0,
      "value": "Deze tip sturen we direct door naar de organisator van de activiteit en tonen we niet op de website. Bijvoorbeeld: “We konden de gids niet altijd goed verstaan” of 'De workshop duurde vrijlang'."
    }],
    values: {
      br: __jsx("br", null)
    }
  }))), __jsx(PublishButton, {
    size: "large",
    type: "submit",
    submitting: isSubmitting
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "EAHVhY",
    defaultMessage: [{
      "type": 0,
      "value": "Beoordeling publiceren"
    }]
  })), __jsx(NeutralBody, {
    variant: "small"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "Oj0TRM",
    defaultMessage: [{
      "type": 0,
      "value": "Je beoordeling is direct zichtbaar op de website"
    }]
  }))));
};
const NeutralBody = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "ActivityReviewForm__NeutralBody",
  componentId: "sc-1tntu1z-0"
})(["color:", ";margin-bottom:2rem;"], ({
  theme
}) => theme.colors.neutral['50']);
const BoldBody = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "ActivityReviewForm__BoldBody",
  componentId: "sc-1tntu1z-1"
})(["font-weight:600;margin-bottom:", ";"], ({
  theme
}) => theme.spacing['20_Tiny']);
const PublishButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "ActivityReviewForm__PublishButton",
  componentId: "sc-1tntu1z-2"
})(["margin-bottom:1rem;margin-top:", ";width:100%;@media screen and (min-width:", "){width:unset;}@media screen and (min-width:", "){margin-top:", ";}"], ({
  theme
}) => theme.spacing['50_Semi'], ({
  theme
}) => theme.mediaQueries.xs, ({
  theme
}) => theme.mediaQueries.m, ({
  theme
}) => theme.spacing['80_XXLarge']);
const TextArea = (0, _styledComponents.default)(_TextInput.TextInputField).attrs({
  type: 'textarea'
}).withConfig({
  displayName: "ActivityReviewForm__TextArea",
  componentId: "sc-1tntu1z-3"
})(["min-height:19.2rem;"]);
const ReviewSelectInput = (0, _styledComponents.default)(_SelectInput.default).withConfig({
  displayName: "ActivityReviewForm__ReviewSelectInput",
  componentId: "sc-1tntu1z-4"
})(["max-width:20.8rem;"]);
const SummaryInputField = (0, _styledComponents.default)(_TextInput.TextInputField).withConfig({
  displayName: "ActivityReviewForm__SummaryInputField",
  componentId: "sc-1tntu1z-5"
})(["@media screen and (max-width:", "){min-height:14.4rem;}"], ({
  theme
}) => theme.mediaQueries.s);
var _default = exports.default = ActivityReviewForm;